function strVal(v: unknown): string {
  if (v == null) return '';
  return String(v).trim();
}

export function formatGrupoEmpresarialLabel(grupo: unknown): string | undefined {
  if (!grupo || typeof grupo !== 'object') return undefined;
  const g = grupo as Record<string, unknown>;
  const alias = strVal(g.alias);
  if (alias) return alias;

  const decomsa = strVal(g.grpAliasDecomsa);
  const equilibrio = strVal(g.grpAliasEquilibrio);

  if (decomsa && equilibrio) {
    if (decomsa === equilibrio) return decomsa;
    return `${decomsa} / ${equilibrio}`;
  }
  return decomsa || equilibrio || undefined;
}

export function resolveGrupoEmpresarialFromRaw(raw: unknown): string | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  const r = raw as Record<string, unknown>;
  const data = r.data as Record<string, unknown> | undefined;
  const empresa = (data?.empresa ?? r.empresa) as Record<string, unknown> | undefined;

  const grupo = data?.grupoEmpresarial
    ?? r.grupoEmpresarial
    ?? empresa?.grupoEmpresarial;

  const formatted = formatGrupoEmpresarialLabel(grupo);
  if (formatted) return formatted;

  return strVal(r.grupoAlias ?? data?.grupoAlias ?? r.grupoEmpresarialAlias) || undefined;
}

export interface KanbanEmpresaInfo {
  id?: string | number;
  rfc?: string;
  razonSocial?: string;
  grupoEmpresarial?: string;
}

export function getKanbanEmpresa(raw: unknown): KanbanEmpresaInfo {
  if (!raw || typeof raw !== 'object') return {};
  const r = raw as Record<string, unknown>;
  const data = r.data as Record<string, unknown> | undefined;
  const empresa = (data?.empresa ?? r.empresa) as Record<string, unknown> | undefined;
  const grupoEmpresarial = resolveGrupoEmpresarialFromRaw(raw);

  if (empresa) {
    const id = empresa.id;
    return {
      id: id != null && id !== '' ? id as string | number : undefined,
      rfc: strVal(empresa.rfc) || undefined,
      razonSocial: strVal(empresa.razonSocial) || undefined,
      grupoEmpresarial,
    };
  }

  const flatId = r.empresaId ?? data?.empresaId;
  return {
    id: flatId != null && flatId !== '' ? flatId as string | number : undefined,
    rfc: strVal(r.empresaRfc) || undefined,
    razonSocial: strVal(r.empresaRazonSocial) || undefined,
    grupoEmpresarial,
  };
}

export function resolveEmpresaContextFromDetail(detail: unknown): Partial<KanbanEmpresaInfo> {
  const empresa = getKanbanEmpresa(detail);
  return {
    rfc: empresa.rfc,
    razonSocial: empresa.razonSocial,
    grupoEmpresarial: empresa.grupoEmpresarial,
  };
}
